// @mui
import { Grid, Card, CardHeader, Divider, Table, TableBody, TableContainer, Typography, Box, TableRow, TableCell } from '@mui/material';

// @types
import Scrollbar from 'src/components/Scrollbar';
import { TableHeadCustom } from 'src/components/table';
//Localization
import useLocales from 'src/hooks/useLocales';
import { IFloor } from 'src/@types/Choqorak/Settings/Floor';
import { useNavigate } from 'react-router';

type Props = {
  row: IFloor;
  clearFloor: () => void;
};

export default function FloorDetailTableRow({ row, clearFloor }: Props) {
  const { translate } = useLocales(); // Localization
  const navigate = useNavigate();

  const FLOOR_HEAD = [
    { id: 'floorId', label: `${translate('GeneralFields.No')}`, align: 'left' },
    { id: 'floorCode', label: `${translate('Floor.FloorCode')}`, align: 'left' },
  ];

  const SHOP_HEAD = [
    { id: 'shopId', label: `${translate('GeneralFields.No')}`, align: 'left' },
    { id: 'shopCode', label: `${translate('Shop.ShopCode')}`, align: 'left' },
    { id: 'shopStatus', label: `${translate('Shop.ShopStatus')}`, align: 'left' },
    { id: 'shopWidth', label: `${translate('Shop.ShopWidth')}`, align: 'left' },
    { id: 'shopLength', label: `${translate('Shop.ShopLength')}`, align: 'left' },
    { id: 'rentPerMonth', label: `${translate('Shop.RentPerMonth')}`, align: 'left' },
  ];

  return (
    <>
      {/* Floors Table */}
      <Grid item xs={12}>
        <Card
          sx={{
            p: 3,
            mb: 3,
            backgroundColor: 'grey.800',
            color: 'grey.100',
            borderRadius: 2,
            boxShadow: 3,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Block Info */}
            <Box sx={{ flex: 1 }}>
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 'bold' }}>
                {translate('Block.BlockInfo')}
              </Typography>

              {/* <Typography variant="body1">
                <strong>{translate('Floor.FloorName')}: </strong> {row.FloorName}
              </Typography>
              <Typography variant="body1">
                <strong>{translate('Floor.FloorAddress')}: </strong> {row.blockAddress}
              </Typography> */}
            </Box>

            {/* Block Image */}
            <Box sx={{ flexShrink: 0, ml: 2 }}>
              <img
                src="/Images/block.webp" // Replace with the actual path to the block image
                alt={translate('blockDetail.imageAlt')}
                style={{
                  width: '150px',
                  height: '150px',
                  borderRadius: '8px',
                  objectFit: 'cover',
                }}
              />
            </Box>
          </Box>
        </Card>
      </Grid>

      {/* Floors Table */}
      <Grid item xs={12}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold' }}>
            {translate('Block.Block')}
          </Typography>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 720 }}>
              <Table>
                <TableHeadCustom headLabel={FLOOR_HEAD} />
                {/* <TableBody>
                  {row.blocks.length > 0 ? (
                    row.blocks.map((floor, index) => (
                      <TableRow key={floor.floorId}>
                        <TableCell align="left" sx={{ padding: '8px' }}>
                          {index + 1}
                        </TableCell>
                        <TableCell align="left">{floor.floorCode}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={FLOOR_HEAD.length}>
                        {translate('Block.NoData')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody> */}
              </Table>
            </TableContainer>
          </Scrollbar>
          <Divider />
        </Card>
      </Grid>

      {/* Shops Table */}
      <Grid item xs={12} style={{ marginTop: 30 }}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold' }}>
            {translate('Shop.Shop')}
          </Typography>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 720 }}>
              <Table>
                <TableHeadCustom headLabel={SHOP_HEAD} />
                {/* <TableBody>
                  {row.shops.length > 0 ? (
                    row.shops.map((shop, index) => (
                      <TableRow key={shop.shopId}>
                        <TableCell align="left">{index + 1}</TableCell>
                        <TableCell align="left">{shop.shopCode}</TableCell>
                        <TableCell align="left">{shop.shopStatus}</TableCell>
                        <TableCell align="left">{shop.shopWidth}</TableCell>
                        <TableCell align="left">{shop.shopLength}</TableCell>
                        <TableCell align="left">{shop.rentPerMonth}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={SHOP_HEAD.length}>
                        {translate('blockDetail.noShops')}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody> */}
              </Table>
            </TableContainer>
          </Scrollbar>
          <Divider sx={{ borderColor: 'grey.700' }} />
        </Card>
      </Grid>
    </>
  );
}

//---------------------------------------------

